import { render, staticRenderFns } from "./AddDataCat.vue?vue&type=template&id=05b74b92&"
import script from "./AddDataCat.vue?vue&type=script&lang=ts&"
export * from "./AddDataCat.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports